(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["era-welcome"]) return;
  try {
    
(() => {
  const dialog = document.getElementById('EraWelcome');
  if (!dialog || typeof dialog.showModal !== 'function') return;
  const tab = document.getElementById('EraWelcomeTab');
  const tabDismissKey = 'era_welcome_tab_dismissed';
  const tabDismissed = () => { try { return sessionStorage.getItem(tabDismissKey) === '1'; } catch { return false; } };
  const hideTab = () => { if (tab) tab.hidden = true; };
  const isThemePreview = window.Shopify?.designMode === true || new URLSearchParams(window.location.search).has('preview_theme_id');
  const showTab = () => { if (tab && !tabDismissed() && !dialog.open) tab.hidden = false; };
  if (tab) {
    tab.querySelector('[data-era-tab-open]')?.addEventListener('click', () => { hideTab(); if (!dialog.open) dialog.showModal(); });
    tab.querySelector('[data-era-tab-close]')?.addEventListener('click', () => {
      hideTab(); try { sessionStorage.setItem(tabDismissKey, '1'); } catch {}
    });
  }
  const key = 'era_welcome_v1';
  const success = dialog.querySelector('[data-success]');
  const errors = dialog.querySelector('[data-errors]');
  const read = () => { try { return JSON.parse(localStorage.getItem(key) || '{}'); } catch { return {}; } };
  const save = (value) => { try { localStorage.setItem(key, JSON.stringify(value)); } catch {} };
  const open = () => { if (!dialog.open && !document.querySelector('dialog[open]')) dialog.showModal(); };
  if (success) { save({ subscribed: true }); hideTab(); open(); }
  else if (errors) { hideTab(); open(); }
  else {
    const previous = read();
    if (!previous.subscribed || isThemePreview) {
      showTab();
      if (!previous.subscribed && (!previous.dismissed || Date.now() - previous.dismissed > 7 * 86400000)) {
        setTimeout(() => { hideTab(); open(); }, Number(dialog.dataset.delay) || 10000);
      }
    }
  }
  const copyButton = dialog.querySelector('[data-era-copy-code]');
  if (copyButton) copyButton.addEventListener('click', async () => {
    try { await navigator.clipboard.writeText('BIENVENIDA10'); copyButton.textContent = '¡Código copiado!'; }
    catch { copyButton.textContent = 'Código: BIENVENIDA10'; }
  });
  dialog.querySelectorAll('.era-welcome__close,.era-welcome__later').forEach(button => button.addEventListener('click', () => dialog.close()));
  dialog.addEventListener('click', event => { const box = dialog.getBoundingClientRect(); if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close(); });
  dialog.addEventListener('close', () => {
    if (!success) { save({ dismissed: Date.now() }); showTab(); }
    else hideTab();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
